<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>RabbitMQ推送服务列表</span>
          <el-button style="float: right;" type="primary" @click="addBtn">创建
          </el-button>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="输入名称进行搜索" v-model="search" @keyup.enter.native="searchBtn"
            maxlength="500">
          </el-input>
          <el-button @click="searchBtn" slot="append" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="topic" label="推送主题（topic）" width="200px"></el-table-column>
          <el-table-column prop="expirationTime" label="缓存过期时间" width="150px" :formatter="getExpirationTimeShow">
          </el-table-column>
          <el-table-column prop="pushKey" label="密钥"></el-table-column>
          <el-table-column prop="pushType" label="推送类型" :formatter="getPushTypeName"></el-table-column>
          <el-table-column prop="enable" label="状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.enable" @change="changePushStatus(scope.row)" :active-value="1"
                :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
              <span v-if="scope.row.enable==0" style="color: red;font-weight: bold;">停用</span>
              <span v-else-if="scope.row.enable==1" style="color: green;font-weight: bold;">启用</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column prop="createDate" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="50px" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteBtn(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10,50,100,200,500,1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs"

  export default {
    data() {
      return {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "", //搜索
        tableData: [],
        multipleSelection: [],
      };
    },
    created() { },
    methods: {

      getPushTypeName(row) {
        if (row.pushType) {
          let pushTypeName = '';
          let pushTypeStr = String(row.pushType);
          if (pushTypeStr.indexOf("1") !== -1) {
            pushTypeName += "设备json数据,"
          }
          if (pushTypeStr.indexOf("2") !== -1) {
            pushTypeName += "设备上下线消息,"
          }
          return pushTypeName.substring(0, pushTypeName.length - 1)
        } else {
          return '--'
        }

      },
      getExpirationTimeShow(row) {
        var duration = row.expirationTime * 1000
        let str = ''
        let days = '',
          hours = '',
          minutes = '',
          seconds = ''
        let day = 24 * 60 * 60 * 1000,
          hour = 60 * 60 * 1000,
          minute = 60 * 1000,
          second = 1000
        if (duration >= day) {
          days = Math.floor(duration / day) + '天'
          hours = Math.floor(duration % day / hour) < 1 ? '' : (Math.floor(duration % day / hour) + '小时')
        } else if (duration >= hour && duration < day) {
          hours = Math.floor(duration / hour) + '小时'
          minutes = Math.floor(duration % hour / minute) < 1 ? '' : (Math.floor(duration % hour / minute) + '分钟')
        } else if (duration > minute && duration < hour) {
          minutes = Math.floor(duration / minute) + '分钟'
          seconds = Math.floor(duration % minute / second) < 1 ? '' : (Math.floor(duration % minute / second) + '秒')
        } else if (duration < minute) {
          seconds = Math.floor(duration / second) + '秒'
        }
        return days + hours + minutes + seconds
      },

      //跳转创建网关页
      addBtn() {
        this.$router.push({
          path: "/pushService/rabbitMQPushAdd"
        });
      },
      //时间格式化
      dateTimeFormat(row, column) {
        var date = row[column.property];
        if (date === undefined) {
          return "";
        }
        return dayjs(new Date(date)).format("YYYY-MM-DD HH:mm:ss");
      },
      init() {
        this.getpageList();
      },
      //获取列表
      getpageList() {
        let para = {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          name: this.search,
          pushMode: 2 //RabbitMQ推送
        }
        this.loading = true; /*显示加载条*/
        API.pushServiceList(para).then(res => {
          if (res.code == 1) {
            this.tableData = res.data.resultPage
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false; /*显示加载条*/
        })
      },
      //跳转到业户详情页
      detailBtn(id) {
        this.$router.push({
          path: "/pushService/rabbitMQPushAdd",
          query: {
            id: id,
            flag: 'edit',
          }
        });
      },
      //输入搜索功能
      searchBtn() {
        this.identity = "";
        this.getpageList();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.getpageList();
      },
      //选中的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //改变推送服务状态
      changePushStatus(data) {
        if (!data || data.id == "") {
          this.$message({
            message: "数据参数出错",
            type: "warning"
          });
        }
        var json = {
          id: data.id,
          enable: data.enable
        }
        API.pushServiceSave(json).then(res => {
          if (res.code == 1) {
            this.$message({
              message: "推送服务状态修改成功。",
              type: "success"
            });
          } else {
            this.$message({
              message: "推送服务状态修改失败：" + res.msg,
              type: "error"
            });
            data.enable = (data.enable == 1 ? 0 : 1)
          }
        });
      },
      //删除
      deleteBtn(row) {
        this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let para = {
            ids: row.id
          }
          API.delPushService(para).then(res => {
            if (res.code == 1) {
              this.$message.success("删除成功！");
              this.getpageList();
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getpageList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList()
      }
    },
    mounted() {
      this.init()
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/rabbitMQPushList.vue